import { JobService } from "./Job.service";

export default {
  jobService: {
    class: JobService,
    public: true,
    arguments: [{ $ref: "apiService" }]
  }
};
